import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmployeeProfilePage from "@/pages/employee/EmployeeProfilePage";

export const Route = createFileRoute("/employee/profile")({
  head: () => pageHead("Employee · Profile", "AKIVA employee · profile portal.", "/employee/profile", true),
  component: EmployeeProfilePage,
});
